import axios from "axios";

// Published sticker-tag catalog (curated in idx-pins). The backend itself falls
// back to the legacy hardcoded tag universe for any (sport, feature) scope that
// hasn't been curated, so a non-null result is always authoritative:
//   - non-empty array → those tag_keys are live
//   - empty array     → the scope is curated to zero (show no tag stickers)
//   - null            → endpoint unreachable (e.g. not deployed yet); the caller
//                       should fall back to the legacy tag-options endpoint
const StickerTagsService = {
    getPublishedTags: async (sport: string, feature: string): Promise<string[] | null> => {
        return axios
            .get(`${process.env.REACT_APP_MCTWIST_USER_SERVER}/stickers/tags`, {
                params: { sport, feature },
            })
            .then((response) => {
                // Preserve the backend's null (uncurated/unknown scope → caller
                // uses its heuristic) vs [] (curated to zero → show nothing).
                const data = response.data?.data;
                return (data ?? null) as string[] | null;
            })
            .catch((error) => {
                console.error(error);
                return null;
            });
    },
};

export default StickerTagsService;
